module.exports = __webpack_public_path__ + "img/dossier.d624060b.png";